import React, { Component } from 'react';
import classes from './PatientsCreator.module.css';
import Button from './../../components/UI/Button/Button';
import Input from '../../components/UI/Input/Input';
import {
  createControl,
  validate,
  validateForm,
} from '../../components/form/formFramework';
import Auxiliry from '../../components/Auxiliry/Auxiliry';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  addPatientCard,
  sendCreateCard,
} from '../../store/actions/createPatient';

//Отрисовка инпутов
function createFormControl() {
  return {
    historyNumber: createControl(
      {
        label: '№ истории',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
    IIN: createControl(
      {
        label: 'ИИН',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
    FIO: createControl(
      {
        label: 'Ф.И.О.',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
    regDate: createControl(
      {
        label: 'Дата поступления',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
    diagnosis: createControl(
      {
        label: 'Диагноз',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
    severity: createControl(
      {
        label: 'Степень тяжести',
        errorMessage: 'Поле не может быть пустым',
      },
      { required: true }
    ),
  };
}

class PatientsCreator extends Component {
  // начальный локальный стейт
  state = {
    isFormValid: false,
    formControls: createFormControl(),
  };

  //Отправка заполненых данных инпутов в базу
  addPatientHandler = (event) => {
    event.preventDefault();

    // получение данных из введенных данных в инпут
    const {
      historyNumber,
      IIN,
      FIO,
      regDate,
      diagnosis,
      severity,
    } = this.state.formControls;

    // формирование данных в один обьект
    const patientItem = {
      HistoryId: historyNumber.value,
      IIN: IIN.value,
      FIO: FIO.value,
      regDate: regDate.value,
      diagnosis: diagnosis.value,
      severity: severity.value,
    };
    // Обновление сформированных данных в стейте
    this.props.addPatientCard(patientItem);

    this.setState({
      isFormValid: false,
      formControls: createFormControl(),
    });

    // обнуление стейта
    this.setState({
      isFormValid: false,
      formControls: createFormControl(),
    });

    // отправка на сервер данных полученных из стейта и обнуление стейта
    this.props.sendCreateCard();
  };

  changeHandler = (value, controlName) => {
    const formControls = { ...this.state.formControls };
    const control = { ...formControls[controlName] };

    control.touched = true;
    control.value = value;
    control.valid = validate(control.value, control.validation);

    formControls[controlName] = control;

    this.setState({
      formControls,
      isFormValid: validateForm(formControls),
    });
  };

  //Отрисовка и создание инпутов
  renderControls() {
    return Object.keys(this.state.formControls).map((controlName, index) => {
      const control = this.state.formControls[controlName];

      return (
        <Auxiliry key={controlName + index}>
          <Input
            label={control.label}
            value={control.value}
            valid={control.valid}
            shouldValidate={!!control.validation}
            touched={control.touched}
            errorMessage={control.errorMessage}
            onChange={(event) =>
              this.changeHandler(event.target.value, controlName)
            }
          />
          {index === 0 ? <hr /> : null}
        </Auxiliry>
      );
    });
  }

  // Отрисовка всех элементов на странице
  render() {
    return (
      <div className={classes.PatientsCreator}>
        <div>
          <h1>Добавить пациента</h1>
          <form onSubmit={this.submitHandler}>
            {this.renderControls()}
            <Button
              type="primary"
              onClick={this.addPatientHandler}
              disabled={!this.state.isFormValid}
            >
              Добавить
            </Button>
            <NavLink to="/patients">
              <Button type="success">Отмена</Button>
            </NavLink>
          </form>
        </div>
      </div>
    );
  }
}

// REDUX
function mapStateToProps(state) {
  return {
    patient: state.create.patient,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // изменение данных импута в стейте
    addPatientCard: (item) => dispatch(addPatientCard(item)),
    // отправка стейта на сервер
    sendCreateCard: () => dispatch(sendCreateCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientsCreator);
